import { lazy, Suspense } from 'react';
import { Navigate, Outlet } from 'react-router';
import { AuthGuard } from 'src/auth/guard';
import { LoadingScreen } from 'src/components/loading-screen';
import DashboardLayout from 'src/layouts/dashboard/layout';
import { paths } from '../../paths';

// ----------------------------------------------------------------------

const FollowLazadaPage = lazy(() => import('src/pages/dashboard/services/lazada-services/follow'));

const LikeLazadaPage = lazy(() => import('src/pages/dashboard/services/lazada-services/like'));

export const lazadaRoutes = [
  {
    path: '',
    element: (
      <AuthGuard>
        <DashboardLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    ),
    children: [
      { path: paths.lazada.root, element: <Navigate to={paths.lazada.follow} replace /> },
      { path: paths.lazada.follow, element: <FollowLazadaPage /> },
      { path: paths.lazada.like, element: <LikeLazadaPage /> },
    ],
  },
];
